//20級パッケージの11級
// 10級パッケージの1級と同様

type ckptTypeForGrade_9_20kyu = 'しっかり体を倒す' | '足を前に前に' | '腕ふり';

export const ckptForGrade_9_20kyu: ckptTypeForGrade_9_20kyu[] = [
  'しっかり体を倒す',
  '足を前に前に',
  '腕ふり',
];

export const requirement_9_20kyu: ckptTypeForGrade_9_20kyu[] = [
  'しっかり体を倒す',
  '足を前に前に',
];

export type ckptDetails_9_20 =
  | '六歩以上体を倒せている'
  | '足の流れ'
  | 'リーチアウト'
  | '足の上がり'
  | 'うでを前に前に振る'
  | '足を壁押しのように動かす';

type allCheckpoints_9_20kyu_type = {
  [key in ckptTypeForGrade_9_20kyu]: ckptDetails_9_20[];
};

export const allCheckPoints_9_20kyu: allCheckpoints_9_20kyu_type = {
  しっかり体を倒す: ['六歩以上体を倒せている'],
  足を前に前に: [
    '足の流れ',
    '足の上がり',
    'リーチアウト',
    '足を壁押しのように動かす',
  ],
  腕ふり: ['うでを前に前に振る'],
};

export const borderLine_9_20kyu: allCheckpoints_9_20kyu_type = {
  しっかり体を倒す: ['六歩以上体を倒せている'],
  足を前に前に: ['足の流れ', '足の上がり'],
  腕ふり: ['うでを前に前に振る'],
};
